import $ from 'jquery'

const Logger = (($) => {

	class Logger {

		constructor(){

		}

		warn(msg){
			if(console && console.warn){
				console.warn(msg);
			}
		}

		dir(obj){
			if(console && console.dir){
				console.dir(msg);
			}
		}

		error(msg){
			if(console && console.error){
				console.error(msg);
			}
		}

		log(msg){
			if(console && console.log){
				console.log(msg);
			}
		}
	}

	return new Logger()
})($)

export default Logger
